module.exports = __webpack_public_path__ + "static/media/login.98bee709.wav";